import { read } from 'ktx-parse';
export { read as default };